/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Items_SubtotalInputs */

const vi_order_items_subtotal = /** @type {(inputs: Order_Items_SubtotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng tiền hàng`)
};

/**

* @param {Order_Items_SubtotalInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_items_subtotal = /** @type {((inputs?: Order_Items_SubtotalInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Items_SubtotalInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_items_subtotal(inputs)
});